import { MockupCheckin, MockupUnderstand, MockupTools, MockupDashboard } from "./Mockups";
import { Lock } from "lucide-react";

export function Product() {
  return (
    <section id="producto" className="relative bg-surface py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            Una experiencia diseñada <br className="hidden sm:block" /> para <span className="text-gradient-brand">el momento real</span>
          </h2>
        </div>

        <div className="mt-20 space-y-24">
          <Row
            eyebrow="01 · Check-in emocional"
            title="Expresa cómo te sientes en segundos"
            text="8 emociones reales para nombrar lo que pasa por dentro. Sin formularios, sin presión."
            mockup={<MockupCheckin />}
          />
          <Row
            reverse
            eyebrow="02 · Entender lo que pasa"
            title="Pon nombre a lo que hay detrás"
            text="Pequeñas pistas para identificar el origen real de la emoción y dejar de pelear con síntomas."
            mockup={<MockupUnderstand />}
          />
          <Row
            eyebrow="03 · ¿Qué puedo hacer ahora?"
            title="Herramientas para este momento"
            text="Recursos personalizados según la emoción: respirar, ordenar la mente, cambiar el foco o dar un paso pequeño."
            mockup={<MockupTools />}
          />

          <div className="grid gap-10 lg:grid-cols-12 lg:items-center">
            <div className="lg:col-span-5">
              <p className="text-xs font-medium uppercase tracking-wider text-primary">04 · Dashboard empresa</p>
              <h3 className="mt-3 text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">
                Tendencias emocionales del equipo, <span className="text-gradient-brand">siempre anónimas</span>
              </h3>
              <p className="mt-4 text-muted-foreground">
                Estrés semanal, engagement, riesgo de burnout y patrones agregados. Datos para decidir, sin invadir.
              </p>
              <div className="mt-5 flex items-center gap-2 rounded-full border border-border bg-card px-3 py-1.5 text-xs text-foreground w-fit">
                <Lock className="h-3.5 w-3.5 text-primary" />
                La privacidad de los empleados es prioritaria.
              </div>
            </div>
            <div className="lg:col-span-7">
              <MockupDashboard />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Row({ eyebrow, title, text, mockup, reverse = false }: { eyebrow: string; title: string; text: string; mockup: React.ReactNode; reverse?: boolean }) {
  return (
    <div className={`grid gap-12 lg:grid-cols-12 lg:items-center ${reverse ? "lg:[&>*:first-child]:order-2" : ""}`}>
      <div className="lg:col-span-6">
        <p className="text-xs font-medium uppercase tracking-wider text-primary">{eyebrow}</p>
        <h3 className="mt-3 text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">{title}</h3>
        <p className="mt-4 text-muted-foreground">{text}</p>
      </div>
      <div className="lg:col-span-6 flex justify-center">{mockup}</div>
    </div>
  );
}
